import { TipoArquivoProntuarioEnum } from '../service-proxies/service-proxies';

export class TipoArquivoProntuarioItem {
    constructor(public name: string, public type: TipoArquivoProntuarioEnum) { }
}

export class TipoArquivoProntuarioList {
    list: TipoArquivoProntuarioItem[] = [
        new TipoArquivoProntuarioItem('Exame', TipoArquivoProntuarioEnum._0),
        new TipoArquivoProntuarioItem('Prescricao', TipoArquivoProntuarioEnum._1),
        new TipoArquivoProntuarioItem('Outro', TipoArquivoProntuarioEnum._2),
    ];

    getNome(tipo: TipoArquivoProntuarioEnum): string {
        const item = this.list.find(x => x.type === tipo);
        return item ? item.name : 'Nome não encontrado';
    }
}